import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { RevenueManagementBaseData, RevenueManagementProperties, Supplier_OficeID } from '../Models/RevenueManagementProperties';
import { FlightSearchScreenRights, FrontBaggageAllowanceType, modifyFlights, ChangeRBDParamsGalileo } from '../Models/FlightSearchResponseProperties';
import { RevalidateItineraryRequest } from '../Models/RevalidateFlightRequest';
import { AirSegmentStopDetail, FlightSearchBaseData, FlightSearchHistory, FlightSearchRights } from '../Models/FlightSearchProperties';
import { AirPricingSolution } from '../Models/AirPricingSolutionProperties';
import { AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { ImportPnrAgencyDetails, ImportPnrDetails, ImportPNREntryProprties } from '../Models/ImportPnrProperties';
import { PassengerCreationResponse, UpdatePriceDetails, ModifyDataCarry } from '../Models/BookingPassengerTicketIssuanceProperties';
import { BranchInformationProperties } from '../Models/BranchInformationProperties';
import { FlyDubaiAnxiHandling } from '../Models/TicketIssuanceProperties';
import { AdvCalendarSearchResponse } from '../Models/AdvCalendarSearchPropertise';
import { FlightSearchNewResponseProperties, MulticityResponseFlightsNew } from '../Models/flight-results-response-properties';

@Injectable({
  providedIn: 'root'
})
export class FlightSearchService {

  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  GetBranchForPrint(param): Observable<BranchInformationProperties> {
    return this.http.get<BranchInformationProperties>(this.baseUrl + '/BranchInformation/GetBranchForPrint/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
 
 
  ModifyBooking(modify): Observable<PassengerCreationResponse> {
    this.showSpinner.next(true);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/ModifyBooking', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
 
  spiceModifySell(airPricingSolution): Observable<FlightSearchNewResponseProperties> {
    this.showSpinner.next(true);
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/SpiceModifySell', airPricingSolution, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }


  modifySpiceBooking(modifyFlights): Observable<modifyFlights> {
    return this.http.post<modifyFlights>(this.baseUrl + '/FlightSearch/ModifySpiceBooking', modifyFlights, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }
 
  GetRevenueBaseData(): Observable<RevenueManagementBaseData> {
    return this.http.get<RevenueManagementBaseData>(this.baseUrl + '/RevenueManagement/GetRevenueManagementBaseData/')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
 
  GetFlightBaseData(): Observable<FlightSearchBaseData> {

    return this.http.get<FlightSearchBaseData>(this.baseUrl + '/FlightSearch/GetAllFlightData/').pipe();

  }

  RevalidateFilght(obj): Observable<boolean> {
    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/RevalidateFilght', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }

  
 
  InitialBook(airPricingSolution): Observable<FlightSearchNewResponseProperties> {
    this.showSpinner.next(true);
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/ChangeGalileoRBD', airPricingSolution, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  GetFlightFareRules(airPricingSolution): Observable<FlightSearchNewResponseProperties> {
    this.showSpinner.next(true);
    return this.http.post<FlightSearchNewResponseProperties>(this.baseUrl + '/FlightSearch/GetFlightFareRules', airPricingSolution, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  
  InitialBookMulti(airPricingSolution): Observable<MulticityResponseFlightsNew> {
    this.showSpinner.next(true);
    return this.http.post<MulticityResponseFlightsNew>(this.baseUrl + '/FlightSearch/ChangeMultiGalileoRBD', airPricingSolution, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  spiceBaggage(transactionIdenti): Observable<FrontBaggageAllowanceType[]> {
    this.showSpinner.next(true);
    return this.http.post<FrontBaggageAllowanceType[]>(this.baseUrl + '/FlightSearch/spiceBaggage', transactionIdenti, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  GetAirSegmentStopDetails(param): Observable<AirSegmentStopDetail[]> {
    return this.http.get<AirSegmentStopDetail[]>(this.baseUrl + '/FlightSearch/GetAirSegmentStopDetails/' + param)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  GetAgencyForPrint(param): Observable<AgencyMasterProperties> {
    return this.http.get<AgencyMasterProperties>(this.baseUrl + '/AgencyMaster/GetAgencyForPrint/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  
  CheckFlightResultsScreenRights(param, isAgency): Observable<FlightSearchScreenRights> {
    return this.http.get<FlightSearchScreenRights>(this.baseUrl + '/FlightSearch/CheckFlightResultsScreenRights/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CheckFlightSearchScreenRights(param, isAgency): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/FlightSearch/CheckFlightSearchScreenRights/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CheckImportRights(param, isAgency): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/FlightSearch/CheckImportRights/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  getFlightSearchHistory(userId: number, agencyId: string): Observable<FlightSearchHistory[]> {
    return this.http.get<FlightSearchHistory[]>(this.baseUrl + '/FlightSearch/GetFlightSearchHistory/' + userId + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  flightSearchHistoryInsert(flightHistoryObj: FlightSearchHistory): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/AddFlightSearchHistory', flightHistoryObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }



 

  SubmitAddPassenger(obj): Observable<UpdatePriceDetails> {
    this.showSpinner.next(true);
    return this.http.post<UpdatePriceDetails>(this.baseUrl + '/FlightSearch/SubmitAddPassengerToB', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }

  RmvPassengerFrmBooking(rmvPsngr): Observable<ModifyDataCarry> {
    this.showSpinner.next(true);
    return this.http.post<ModifyDataCarry>(this.baseUrl + '/FlightSearch/RmvPassengerFrmBookingS', rmvPsngr, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }

  //RmvPassengerFrmBooking(rmvPsngr): Observable<PassengerCreationResponse> {
  //  this.showSpinner.next(true);
  //  return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/RmvPassengerFrmBookingS', rmvPsngr, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  //}

  SubmitAnxiToBooking(modify): Observable<ModifyDataCarry> {
    this.showSpinner.next(true);
    return this.http.post<ModifyDataCarry>(this.baseUrl + '/FlightSearch/SubmitAnxiToBooking', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  CommitModifyRequest(ModifyDataCarry): Observable<PassengerCreationResponse> {
    this.showSpinner.next(true);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/CommitModifyBookings', ModifyDataCarry, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  //SubmitAnxiToBooking(modify): Observable<PassengerCreationResponse> {
  //  this.showSpinner.next(true);
  //  return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/SubmitAnxiToBooking', modify, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  //}

  FZAddAnxillariesToBooking(modify): Observable<FlyDubaiAnxiHandling> {
    this.showSpinner.next(true);
    return this.http.post<FlyDubaiAnxiHandling>(this.baseUrl + '/FlightSearch/FZAddAnxillariesToBooking', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }


  FZRemoveAnxiFromPnr(modify): Observable<ModifyDataCarry> {
    this.showSpinner.next(true);
    return this.http.post<ModifyDataCarry>(this.baseUrl + '/FlightSearch/FZRemoveAnxiFromPnr', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  //FZRemoveAnxiFromPnr(modify): Observable<PassengerCreationResponse> {
  //  this.showSpinner.next(true);
  //  return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/FZRemoveAnxiFromPnr', modify, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  //}
  FZAddSeatToBooking(modify): Observable<ModifyDataCarry> {
    this.showSpinner.next(true);
    return this.http.post<ModifyDataCarry>(this.baseUrl + '/FlightSearch/FZAddSeatToBooking', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  //FZAddSeatToBooking(modify): Observable<PassengerCreationResponse> {
  //  this.showSpinner.next(true);
  //  return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/FZAddSeatToBooking', modify, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  //}
  FZRemoveSeatFromPnr(modify): Observable<ModifyDataCarry> {
    this.showSpinner.next(true);
    return this.http.post<ModifyDataCarry>(this.baseUrl + '/FlightSearch/FZRemoveSeatFromPnr', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  //FZRemoveSeatFromPnr(modify): Observable<PassengerCreationResponse> {
  //  this.showSpinner.next(true);
  //  return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/FZRemoveSeatFromPnr', modify, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  //}
  FZAddToCart(modify): Observable<ModifyDataCarry> {
    this.showSpinner.next(true);
    return this.http.post<ModifyDataCarry>(this.baseUrl + '/FlightSearch/FZAddToCart', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  //FZAddToCart(modify): Observable<PassengerCreationResponse> {
  //  this.showSpinner.next(true);
  //  return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/FZAddToCart', modify, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  //}

  FlyDubaiDateJourneyModify(modifyFlights): Observable<modifyFlights> {
    return this.http.post<modifyFlights>(this.baseUrl + '/FlightSearch/FlyDubaiDateJourneyModification', modifyFlights, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => { return throwError(error); }))
  }

  ConfirmAddPassengerBooking(modify): Observable<PassengerCreationResponse> {
    this.showSpinner.next(true);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/ConfirmAddPassengerBooking', modify, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }


  GetFlightCalendarResult(FlightSearchObj): Observable<AdvCalendarSearchResponse> {
    return this.http.post<AdvCalendarSearchResponse>(this.baseUrl + '/FlightSearch/GetFlightsCalendarResultSabre', FlightSearchObj, this.httpOptions)
      .pipe(map((Advdata: AdvCalendarSearchResponse) => {
        return Advdata;
      }),
        catchError(error => { return throwError(error); }))
  }

  GetRBDforCabin(airPricingSolution): Observable<ChangeRBDParamsGalileo> {
    return this.http.post<ChangeRBDParamsGalileo>(this.baseUrl + '/FlightSearch/GetRBDCodesForCabin', airPricingSolution, this.httpOptions)
      .pipe(map((Advdata: ChangeRBDParamsGalileo) => {
        return Advdata;
      }),
        catchError(error => { return throwError(error); }))
  }



  //10-June-24
  GetAgencyAndUserGroupTicketRigts(param, agencyId): Observable<FlightSearchRights> {
    return this.http.get<FlightSearchRights>(this.baseUrl + '/FlightSearch/CheckFlightSearchGroupTicketRights/' + param + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }),
        catchError(error => {
          return throwError(error);
        }))
  }
  //end

  importPNR(FlightSearchObj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/ImportPNR/ImportPNR', FlightSearchObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  ImportPNRForIssuedOffline(
    FlightSearchObj: any,
    agentId: number,
    importForAgencyBranch: string
  ): Observable<PassengerCreationResponse> {

    return this.http.post<PassengerCreationResponse>(
      `${this.baseUrl}/ImportPNR/ImportPNRForIssuedOffline?agentId=${agentId}&importForAgencyBranch=${encodeURIComponent(importForAgencyBranch)}`,
      FlightSearchObj,
      this.httpOptions
    ).pipe(
      catchError(error => throwError(() => error))
    );
  }
  GetAllImportPnrEntry(): Observable<ImportPNREntryProprties[]> {
    return this.http.get<ImportPNREntryProprties[]>(this.baseUrl + '/ImportPnrEntry/ImportPnrEntryGetBySupplier')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetGetAllBookingPCCs(supplierId): Observable<Supplier_OficeID[]> {
    return this.http.get<Supplier_OficeID[]>(this.baseUrl + '/ImportPNR/GetGetAllBookingPCCs/' + supplierId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
